import { assignIcon } from './assign';
import { catalogIcon } from './catalog';
import { categoryIcon } from './category';
import { departmentIcon } from './department';
import { programIcon } from './program';
import { projectIcon } from './project';
import { reportIcon } from './report';
import { roomIcon } from './room';
import { roomContentIcon } from './room-content';
import { uploadIcon } from './upload';

export const CatalogIcons = [
    catalogIcon,
    projectIcon,
    departmentIcon,
    reportIcon,
    roomContentIcon,
    roomIcon,
    categoryIcon,
    programIcon,
    assignIcon,
    uploadIcon
]